import React from 'react';
import { useTranslation } from 'react-i18next';
import { SourceSummary, isManuallyAdded } from './sourceFilterTypes';

// The "Added by user" badge, shared by every surface that lists devices (the rules
// editor and the Sources tab). created_via is immutable in the backend, so the badge
// is a fact rather than a guess; the tooltip carries the still-silent nuance.

type ManualBadgeProps = {
  // The fields the decision needs; both SourceSummary and the tab's Source satisfy it.
  source: Pick<SourceSummary, 'created_via' | 'last_update' | 'external_id'>;
  // Prefixes the testid so each surface stays addressable in tests.
  testIdPrefix: string;
  // Text colour class; a table row next to a green link reads better in grey.
  colorClassName?: string;
};

const ManualBadge = ({
  source,
  testIdPrefix,
  colorClassName = 'text-ui-text-secondary-text',
}: ManualBadgeProps) => {
  const { t } = useTranslation();
  if (!isManuallyAdded(source as SourceSummary)) return null;
  return (
    <span
      className={`shrink-0 whitespace-nowrap text-xs ${colorClassName}`}
      title={
        source.last_update && source.last_update !== 'unknown'
          ? t('Added by user')
          : t('Added by user · no data received yet')
      }
      data-testid={`${testIdPrefix}-manual-${source.external_id}`}
    >
      {t('Added by user')}
    </span>
  );
};

export default ManualBadge;
